import { css } from '@emotion/core';
import MediaQueries from '../../../styles/Grid/MediaQueries';

export const containerMarginCss = css({
  marginBottom: 48,
  [MediaQueries.mdAndUp]: {
    marginBottom: 96,
  },
  [MediaQueries.lgAndUp]: {
    marginBottom: 160,
  },
});

export const firstRowCss = css({
  [MediaQueries.lgAndUp]: {
    flexDirection: 'row-reverse',
    flexWrap: 'nowrap',
  },
});

export const statsAndContentCss = css({
  display: 'flex',
  flexDirection: 'column-reverse',
  [MediaQueries.mdAndUp]: {
    flexDirection: 'row',
  },
});

export const atLocationCss = css({
  flexDirection: 'column-reverse',
  [MediaQueries.mdAndUp]: {
    flexDirection: 'row',
    flexWrap: 'nowrap',
  },
});
